import {NgModule} from '@angular/core';
import { CompartilhadoModule } from 'app/compartilhado/compartilhado.module';
import {DxSelectBoxModule} from 'devextreme-angular';
import {VisualizarImagemOriginalRotasModule} from './visualizar-imagem-original-rotas.module';
import { VisualizarImagemOriginalComponent } from '../visualizar-imagem-original.component';

@NgModule({
  imports: [
    VisualizarImagemOriginalRotasModule,
    DxSelectBoxModule,
    CompartilhadoModule
  ],
  declarations: [VisualizarImagemOriginalComponent]
})

export class VisualizarImagemOriginalModule {
}
